import ICON_SEARCH_LIGHT from '../../../public/static/v4/search/icon-search-light.svg';
import ICON_SEARCH from '../../../public/static/v4/search/icon-search.svg';
import Anchor from '../../common/component/Anchor';
import Loading from '../../common/component/Loading';
import SingleText from '../../common/component/SingleText';
import useTheme from '../../common/hook/useTheme';
import {useFetchInfo} from '../../common/util/fetch';
import {decorateText} from '../../common/util/string';
import {sendSearchEventV4} from '../common';
import {ActionType} from '../state/action';
interface IProps {
  keyword: string;
  suggestKeywords: string[];
  search: (keyword: string) => void;
}

export default function SuggestListV4({
  keyword,
  suggestKeywords,
  search,
}: IProps) {
  const {isFetching} = useFetchInfo(ActionType.FetchSuggest);
  const {isLightMode} = useTheme();

  if (isFetching || !suggestKeywords) {
    return <Loading isFull />;
  }

  return (
    <div className="mt-20 mx-18 pb-20">
      <ul>
        {suggestKeywords.map((suggestKeyword, index) => (
          <li key={index} className="mb-28 last:mb-0">
            <Anchor
              display="flex"
              className="flex items-center"
              onClick={() => {
                sendSearchEventV4({
                  viewType: 'searchView',
                  actionName: 'auto_keyword',
                  customProps: {
                    event_layer: 'search',
                    ordnum: index + 1,
                    input_keyword: keyword,
                    click_keyword: suggestKeyword,
                  },
                });
                search(suggestKeyword);
              }}
            >
              <img
                width={28}
                height={28}
                src={isLightMode ? ICON_SEARCH_LIGHT : ICON_SEARCH}
                alt="search"
              />
              <SingleText className="ml-14 s17-medium-grey11">
                {decorateText({
                  text: suggestKeyword,
                  matchStr: keyword,
                  decorator: matched =>
                    isLightMode
                      ? `<bold-black>${matched}</bold-black>`
                      : `<bold-white>${matched}</bold-white>`,
                })}
              </SingleText>
            </Anchor>
          </li>
        ))}
      </ul>
    </div>
  );
}
